import { BaseAPI } from "../base/service"
import { CourseType } from "../enums";

export class LessonAPI extends BaseAPI {
    public watched(classeType: CourseType, classeId: number, lessonId: number): Promise<void> {
        const year = new Date().getFullYear();
        return this.api.post(`${classeType}/${year}/watched-lesson/`, {
            playlist: classeId,
            lesson: lessonId
        })
    }
}